import MessagingListList from './MessagingListsList';

export default MessagingListList;
